import { render, staticRenderFns } from "./TagsPage.vue?vue&type=template&id=44919616"
import script from "./TagsPage.vue?vue&type=script&lang=js"
export * from "./TagsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports